import React, { useEffect, useState } from 'react';
import { getAllDataPointValues } from "../DataPointValue/DataPointValueClient";
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Paper,
    Stack,
    Typography,
    Tooltip, Select
} from '@mui/material';
import MenuItem from "@mui/material/MenuItem";
import {useForm} from "react-hook-form";
import {getAttributesEnhanced} from "../DataPointAttribute/DataPointAttributeClient";


const DynamicMultiSelectGridWide = ({
                                        clearAll,
                                        // fieldDataPointId,
                                        selectorDataPointId,
                                        selectorLabel,
                                        selectorTooltip,
                                        fieldName,
                                        fieldNameMethod,
                                        setValue,
                                        defaultValue,
                                        defaultFilteringMethod = "Includes"
                                    }) => {
    const [checkboxValues, setCheckboxValues] = useState([]);
    const [attributeCheckboxValues, setAttributeCheckboxValues] = useState([]);
    const [selectedValues, setSelectedValues] = useState([]);
    const filteringMethodDropdown = ["","Includes","Excludes"];
    const [selectedFilteringMethod, setSelectedFilteringMethod] = useState('Includes');

    // const {register, handleSubmit} = useForm();

    const columnCount = 4;


    const fetchDataPointValues = React.useCallback(() => {
        console.log("Fetching checkbox grid Data Point Values");

        return getAllDataPointValues()

            .then(data => {
                setCheckboxValues(
                    data.filter(item => item.dataPointId === selectorDataPointId)
                );
            });
    }, [selectorDataPointId]);

    useEffect(() => {
        fetchDataPointValues();
    }, [fetchDataPointValues]);


    const fetchAttributesEnhanced = React.useCallback(() => {
        console.log("Fetching checkbox grid Data Point Values");

        return getAttributesEnhanced()

            .then(data => {
                console.log("Attribute data");
                console.log(data);
                setAttributeCheckboxValues(
                    data
                        .filter(item => Number(item.categoryCode) === selectorDataPointId)
                        .sort((a, b) => a.name.localeCompare(b.name))
                );
                console.log("Attribute Data Point Values");
                console.log(data.filter(item => Number(item.categoryCode) === selectorDataPointId));
                // console.log(data.filter(item => Number(item.categoryCode) === 12020));
            });
    }, [selectorDataPointId]);

    useEffect(() => {
        fetchAttributesEnhanced();
    }, [fetchAttributesEnhanced]);



    //
    // const fetchDataPointValues = () =>
    //     console.log("Fetching checkbox grid Data Point Values");
    //     getAllDataPointValues()

    //         .then(data => {
    //             setCheckboxValues(
    //                 data.filter(item => item.dataPointId === selectorDataPointId)
    //             );
    //         });

    // useEffect(() => {
    //     fetchDataPointValues();
    // }, [selectorDataPointId]);
    //
    // const fetchAttributesEnhanced = () =>
    //     console.log("Fetching checkbox grid Attribute Data Point Values");
    // getAttributesEnhanced()

    //     .then(data => {
    //         setAttributeCheckboxValues(
    //             data.filter(item => Number(item.categoryCode) === selectorDataPointId)
    //         );
    //         console.log("Attribute Data Point Values");
    //         console.log(data.filter(item => Number(item.categoryCode) === selectorDataPointId));
    //     });
    //
    // useEffect(() => {
    //     fetchAttributesEnhanced();
    // }, [selectorDataPointId]);



    // useEffect(() => {
    //     setSelectedValues([]);
    // }, [clearAll]);
    //

    // useEffect(() => {
    //     setSelectedValues([]);
    //     setSelectedFilteringMethod("Includes");
    //
    //     if (fieldName && setValue) {
    //         setValue(fieldName, []);
    //     }
    //
    //     if (fieldNameMethod && setValue) {
    //         setValue(fieldNameMethod, "Includes");
    //     }
    // }, [clearAll, fieldName, fieldNameMethod, setValue]);

    const didMountRef = React.useRef(false);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }

        setSelectedValues([]);
        setSelectedFilteringMethod("Includes");

        setValue(fieldName, []);
        setValue(fieldNameMethod, "Includes");
    }, [clearAll, fieldName, fieldNameMethod, setValue]);


    const handleToggle = (valueId) => {
        setSelectedValues(prev =>
            prev.includes(valueId)
                ? prev.filter(item => item !== valueId)
                : [...prev, valueId]
        );
    };



    // const handleSelectAll = () => {
    // if(selectorDataPointId !== 12020)    setSelectedValues(checkboxValues.map(value => value.mcode));
    //     if(selectorDataPointId === 12020)    setSelectedValues(checkboxValues.map(value => value.id));
    // };

    // const handleSelectAll = () => {
    //     setSelectedValues(
    //         checkboxValues.map(value =>
    //             selectorDataPointId === 12020 ? value.id : value.mcode
    //         )
    //     );
    // };

    const handleSelectAll = () => {
        setSelectedValues(
            displayValues.map(value =>
                selectorDataPointId === 12020
                    ? value.id
                    : value.mcode
            )
        );
    };

    const handleClearAll = () => {
        setSelectedValues([]);
        // setSelectedFilteringMethod(null);
        setValue(fieldName, []);
    };

    // useEffect(() => {
    //     setValue(fieldName, selectedValues);
    // }, [selectedValues, fieldName, setValue]);

    useEffect(() => {
        if (!fieldName) return;

        setValue(fieldName, selectedValues);
    }, [selectedValues, fieldName, setValue]);

    //
    // useEffect(() => {
    //     const values = Array.isArray(defaultValue) ? defaultValue : [];
    //
    //     setSelectedValues(values);
    //
    //     if (fieldName && setValue) {
    //         setValue(fieldName, values);
    //     }
    // }, [defaultValue, fieldName, setValue]);

    // useEffect(() => {
    //     const values = Array.isArray(defaultValue) ? defaultValue : [];
    //
    //     setSelectedValues(values);
    //
    //     if (fieldName && setValue) {
    //         setValue(fieldName, values);
    //     }
    // }, [selectorDataPointId]);
    //

    useEffect(() => {
        const values = Array.isArray(defaultValue) ? defaultValue : [];
        const method = defaultFilteringMethod ?? "Includes";

        setSelectedValues(values);
        setSelectedFilteringMethod(method);

        if (fieldName && setValue) {
            setValue(fieldName, values);
        }

        if (fieldNameMethod && setValue) {
            setValue(fieldNameMethod, method);
        }
    }, [
        defaultValue,
        defaultFilteringMethod,
        fieldName,
        fieldNameMethod,
        setValue
    ]);





    // const handleFilteringMethodChange = (filteringMethodEvent) => {
    //     setSelectedFilteringMethod(filteringMethodEvent.target.value);
    //     console.log("This is for the selected Value");
    //     console.log(filteringMethodEvent.target.value);
    // };
    const handleFilteringMethodChange = (event) => {
        const nextValue = event.target.value;

        setSelectedFilteringMethod(nextValue);

        if (fieldNameMethod && setValue) {
            setValue(fieldNameMethod, nextValue, {
                shouldDirty: true,
                shouldValidate: true
            });
        }
    };


    useEffect(() => {
        if (fieldNameMethod && setValue) {
            setValue(fieldNameMethod, selectedFilteringMethod ?? "");
        }
    }, [fieldNameMethod, selectedFilteringMethod, setValue]);


    const displayValues =
        selectorDataPointId === 12020
            ? attributeCheckboxValues
            : checkboxValues;

    const rowsPerColumn = Math.ceil(displayValues.length / columnCount);

    const columns = Array.from({ length: columnCount }, (_, columnIndex) => {
        const start = columnIndex * rowsPerColumn;
        const end = start + rowsPerColumn;
        return displayValues.slice(start, end);
    });


    //
    // const rowsPerColumn = Math.ceil(checkboxValues.length / columnCount);
    //
    // const columns = Array.from({ length: columnCount }, (_, columnIndex) => {
    //     const start = columnIndex * rowsPerColumn;
    //     const end = start + rowsPerColumn;
    //     return checkboxValues.slice(start, end);
    // });

    return (
        <FormControl sx={{ width: 900 }}>
            <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 1 }}>
                <Tooltip enterDelay={1000} title={selectorTooltip}>
                <Typography  sx={{ fontWeight: 600, cursor: 'pointer'}}>
                    {selectorLabel}
                </Typography>
                </Tooltip>
                <FormControl variant="standard" sx={{ pr: 5, minWidth: 150 }} >
                    {/*<InputLabel sx={{ ml: 1}} htmlFor="filteringMethod">Data Set</InputLabel>*/}


                    {/*<Select*/}
                    {/*    /!*{...register('filteringMethod', { required: true })}*!/*/}
                    {/*    /!*labelId="demo-simple-select-filled-filteringMethod"*!/*/}
                    {/*    id="filteringMethod"*/}
                    {/*    FreeSolo={true}*/}
                    {/*    variant="filled"*/}
                    {/*    label="filteringMethod"*/}
                    {/*    value={selectedFilteringMethod}*/}
                    {/*    onChange={handleFilteringMethodChange}*/}
                    {/*    sx={{ width: 150}}*/}
                    {/*    fieldName={fieldNameMethod}*/}
                    {/*>*/}
                    {/*    {filteringMethodDropdown.map((Item) =>*/}
                    {/*        <MenuItem*/}
                    {/*            // FreeSolo={true}*/}
                    {/*            value={Item}>{Item}</MenuItem>*/}
                    {/*    )}*/}
                    {/*</Select>*/}
                    <Select
                        id={`${fieldNameMethod}-filteringMethod`}
                        variant="standard"
                        label="filteringMethod"
                        value={selectedFilteringMethod}
                        onChange={handleFilteringMethodChange}
                        sx={{ width: 150 }}
                    >
                        {filteringMethodDropdown.map((item) => (
                            <MenuItem key={item} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Button size="small" onClick={handleSelectAll}>
                    Select All
                </Button>

                <Button size="small" onClick={handleClearAll}>
                    Clear All
                </Button>
            </Stack>
            {selectorDataPointId !== 12020 &&
            <Paper
                variant="outlined"
                sx={{
                    p: 1,
                    maxHeight: 220,
                    overflowY: 'auto'
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
                        columnGap: 2
                    }}
                >
                    {columns.map((column, columnIndex) => (
                        <Stack key={columnIndex} spacing={0}>
                            {column.map((value) => (
                                <FormControlLabel
                                    // key={value.id}
                                    key={value.mcode}
                                    sx={{
                                        m: 0,
                                        height: 28,
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: 13,
                                            lineHeight: 1
                                        }
                                    }}
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={selectedValues.includes(value.mcode)}
                                            onChange={() => handleToggle(value.mcode)}
                                            sx={{ py: 0.25 }}
                                        />
                                    }
                                    label={value.name}
                                />
                            ))}
                        </Stack>
                    ))}
                </Box>
            </Paper>
            }
            {selectorDataPointId === 12020 &&
                <Paper
                    variant="outlined"
                    sx={{
                        p: 1,
                        maxHeight: 220,
                        overflowY: 'auto'
                    }}
                >
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
                            columnGap: 2
                        }}
                    >
                        {columns.map((column, columnIndex) => (
                            <Stack key={columnIndex} spacing={0}>
                                {column.map((value) => (
                                    <FormControlLabel
                                        // key={value.id}
                                        key={value.id}
                                        sx={{
                                            m: 0,
                                            height: 28,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: 13
                                            }
                                        }}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={selectedValues.includes(value.id)}
                                                onChange={() => handleToggle(value.id)}
                                                sx={{ py: 0.25 }}
                                            />
                                        }
                                        label={value.name}
                                    />
                                ))}
                            </Stack>
                        ))}
                    </Box>
                </Paper>
            }
        </FormControl>
    );
};

export default DynamicMultiSelectGridWide;